import { pushToDataLayer } from '../datalayer';

export type CloudRetailProductDetail = {
  product: { id: string };
};

export type TrackSearchResultsParams = {
  searchTerm?: string;
  count?: number;
  offset?: number | null;
  sortOrder?: string | null;
  searchType?: string;
  searchMethod?: string;
  listName?: string;
  filters?: Record<string, any>;
  cloudRetail?: {
    productDetails?: Array<CloudRetailProductDetail>;
    filter?: string | null;
    attributionToken?: string | null;
  };
};

export const trackSearchResults = ({
  searchTerm,
  count,
  offset,
  sortOrder,
  searchType,
  searchMethod,
  listName,
  filters,
  cloudRetail,
}: TrackSearchResultsParams) => {
  pushToDataLayer({
    event: 'view_search_results',
    search_term: searchTerm,
    count,
    offset,
    sort_order: sortOrder,
    searchType,
    method: searchMethod,
    item_list_name: listName,
    filters,
    ...(cloudRetail && {
      cloud_retail: {
        productDetails: cloudRetail.productDetails,
        filter: cloudRetail.filter,
        attributionToken: cloudRetail.attributionToken,
      },
    }),
  });
};
